import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "@/utils/api";
import { fmtCurrency, fmtDate, StatusBadge } from "@/utils/format";
import BackorderBadge from "@/components/BackorderBadge";

export default function B2BSiparisDetay() {
  const { siparisId } = useParams();
  const [order, setOrder] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let active = true;
    setLoading(true); setOrder(null); setError("");
    api.get(`/siparisler/${siparisId}`).then(({ data }) => { if (active) setOrder(data); })
      .catch((e) => { if (active) setError([403, 404].includes(e.response?.status)
        ? "Bu sipariş bulunamadı veya görüntüleme yetkiniz yok."
        : "Sipariş detayı yüklenemedi. Listeye dönüp tekrar deneyin."); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [siparisId]);
  return <div className="p-4 lg:p-6 space-y-5">
    <Link to="/b2b/siparisler" className="text-sm font-medium text-[#0D1B3E] underline">← Siparişlerime dön</Link>
    {loading && <p role="status">Sipariş yükleniyor...</p>}
    {error && <p role="alert" className="rounded-lg bg-red-50 p-4 text-red-700">{error}</p>}
    {order && <>
      <header className="rounded-xl border bg-white p-5 space-y-3">
        <div className="flex flex-wrap items-center gap-3"><h1 className="text-xl font-bold text-[#0D1B3E]">{order.siparis_no}</h1><StatusBadge status={order.durum}/><BackorderBadge order={order} compact/></div>
        <p className="text-sm text-slate-500">{fmtDate(order.tarih, true)}</p>
        <p className="text-sm text-slate-500">Fiyatlar sipariş anında kaydedilen, KDV dahil fiyatlardır.</p>
      </header>
      <section aria-label="Sipariş ürünleri" className="space-y-3">
        {(order.satirlar || []).map((line, i) => <article key={`${line.stok_id}-${i}`} className="rounded-xl border bg-white p-4">
          <b className="font-mono text-sm break-all text-[#0D1B3E]">{line.stok_kodu}</b>
          <h2 className="mt-1 font-medium break-words">{line.stok_adi}</h2>
          <dl className="mt-3 grid grid-cols-2 gap-3 text-sm sm:grid-cols-3">
            <div><dt className="text-slate-500">Miktar</dt><dd>{line.miktar} adet</dd></div>
            <div><dt className="text-slate-500">Birim fiyat</dt><dd>{fmtCurrency(line.birim_fiyat)}</dd></div>
            <div><dt className="text-slate-500">Satır toplamı</dt><dd className="font-semibold">{fmtCurrency(line.toplam)}</dd></div>
          </dl>
          {line.bakiyeye_alinan > 0 && <p className="mt-3 text-sm text-amber-700">Sipariş anında bakiyeye alınan: {line.bakiyeye_alinan} adet</p>}
        </article>)}
      </section>
      {order.not && <section className="rounded-xl border bg-white p-4"><h2 className="font-semibold">Sipariş notu</h2><p className="mt-2 whitespace-pre-wrap break-words text-sm">{order.not}</p></section>}
      <div className="flex flex-wrap justify-between gap-3 rounded-xl bg-[#0D1B3E] p-5 font-bold text-white"><span>Sipariş toplamı (KDV dahil)</span><span>{fmtCurrency(order.toplam_tutar)}</span></div>
      <p className="text-xs text-slate-500">Sipariş bilgileri cari ekstrenizden ayrıdır.</p>
    </>}
  </div>;
}
